/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface OrganizationLink { 
    organization_name: string;
    organization_link_kind: OrganizationLink.OrganizationLinkKindEnum;
    organization_user_id?: string;
}
export namespace OrganizationLink {
    export type OrganizationLinkKindEnum = 'REGISTERED' | 'CUSTOM';
    export const OrganizationLinkKindEnum = {
        REGISTERED: 'REGISTERED' as OrganizationLinkKindEnum,
        CUSTOM: 'CUSTOM' as OrganizationLinkKindEnum
    };
}